<template>
    <div class="login">
        <div class="background">
            <img src="../../assets/images/login/icon01.jpg" alt="">
        </div>
        <div class="main">
            <div class="title">财务中台—后台管理系统</div>
            <div class="sect">
                <div class="sect-tit">
                    管理者登录
                </div>
                <div class="item">
                    <div class="item-tit">账户名:</div>
                    <div class="input">
                        <el-input v-model="signInData.userName" placeholder="请输入账户名"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="item-tit">密码:</div>
                    <div class="input">
                        <el-input v-model="signInData.pwd" placeholder="请输入密码" type="password"></el-input>
                    </div>
                </div>
                <el-button type="primary" class="btn" @click="signIn">登录</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../../api/login'
export default {
    name: 'login',
    data () {
        return {
            signInData:{
            },
        }
    },
    created(){
        

    },
    mounted(){
        
    },
    methods:{
        
        async signIn() {

            let data = await api.signIn(this.signInData);
            if(data.data.code == '200') {
                this.$message({
                    type: 'success',
                    message: '登录成功!'
                });
                console.log(data.data.data);
                localStorage.setItem('Token', data.data.data.token);
                localStorage.setItem('roleName', data.data.data.type);
                localStorage.setItem('name', data.data.data.name);
                localStorage.setItem('userName', data.data.data.userName);
                localStorage.setItem('organization', data.data.data.organization);
                localStorage.setItem('userType', data.data.data.userType?data.data.data.userType:0);
                if(data.data.data.type=='仅查看专员'){
                    localStorage.setItem('isHandle', '0');
                }else{
                    localStorage.setItem('isHandle', '1');
                }

                if(data.data.data.type=='仅查看专员'||data.data.data.type=='总管理员'||data.data.data.type=='结算专员'||data.data.data.type=='财务专员'){
                    localStorage.setItem('isPush', '1');
                }else{
                    localStorage.setItem('isPush', '0');
                }
                this.$router.push({ path:'/main' });
            }
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .login{
        display: flex;
        width: 100%;
        height: 100%;
        background-color: #0b1531;
        position: relative;
        .background{
            width: 100%;
            height: 100%;
            img{
                height: 100%;
            }
        }
        .main{
            width: 400px;
            height: 300px;
            position: fixed;
            right: 15%;
            top: 30%;
            .title{
                font-size: 36px;
                color: #2ec0f6;
                text-align: center;
                margin-bottom: 20px;
            }
            .sect{
                background-color: rgba(255, 255, 255, 0.4);
                padding: 20px 20px;
                border-radius: 10px;
                .sect-tit{
                    font-size: 20px;
                    text-align: center;
                    color: #1250ea;
                    letter-spacing:5px;
                    display: flex;
                    justify-content: space-around;
                    margin-bottom: 15px;
                    .t-item{
                        color: #ffffff;
                        cursor: pointer;
                    }
                    .t-item-this{
                        color: #1250ea;
                        border-bottom: 2px solid #1250ea;
                        padding-bottom: 10px;
                        
                    }
                }
                .item{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 15px;
                    .item-tit{
                        font-size: 18px;
                        margin-left: 3px;
                    }
                    .input{
                        width: 250px;
                    }
                }
                .btn{
                    width: 100%;
                    margin-bottom: 10px;
                }
            }
        }
    }
  
</style>
